var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.article.heroImage && _vm.article.heroImage.url)?_c('div',{staticClass:"spotlight-hero"},[_c('img',{staticClass:"spotlight-hero-img",attrs:{"src":_vm.article.heroImage.url,"alt":_vm.article.artistName}})]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }